export const RegistrationStatus = [
    { name: 'NEW', code: 'NEW' },
    { name: 'APPROVED', code: 'APPROVED' },
    { name: 'REJECTED', code: 'REJECTED' },
    { name: 'HOLD', code: 'HOLD' },
    { name: 'CANCELLED', code: 'CANCELLED' },
    { name: 'RESUBMISSION', code: 'RESUBMISSION' },
]